<template>
    <span>
        <chat></chat>
    </span>
</template>

<script>
import Chat from '@/components/Chat';

export default {
    name: 'cadchat',
    components: {
        Chat
    }
};
</script>